/*eslint-disable*/
import {mapState} from 'vuex'

export default {
  data () {
    return {
      stageFinished: false
    }
  },
  mounted () {
    this.$echo.private(`stage.${this.user.id}`).listen('StartStage', data => {
      let stage = data.stage;
      if (stage.level.id === this.level.id) {
        if (this.currentStage.id === stage.id) {
          this.currentStage.isStarted = true;
          this.setGame();
        } else if (stage.position === this.currentStage.position + 1) {
          this.currentStage.isCompleted = true;
          this.setParameters();
          this.currentStage.isStarted = true;
        }
      }
    }).listen('FinishStage', data => {
      let stage = data.stage;
      if (this.currentStage.id === stage.id) {
        this.$toasted.info(this.$i18n.t('olympiads.olympiads_stageSocket_info'));
        if (this.games.every(game => game.isCompleted)) {
          setTimeout(() => {
            this.$router.push({name: 'olympiads:stage-results', params: {id: this.currentStage.id}});
          }, 1000);
          return;
        }
        this.isLoading = true;
        this.games.forEach(game => {
          game.isCompleted = true;
        });
        this.stageFinished = true;
      }
    });
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  }
}